import React, { Fragment, useContext, useState, useEffect } from "react";
import { useMutation, useQuery, useSubscription } from "@apollo/client";
import { Link, NavLink } from "react-router-dom";
import styled from "styled-components";
// import { SearchBox } from 'app/components/SearchBox';
// import { Chat } from '../Chat';
import { BellFilled } from "@ant-design/icons";
import Badge from "antd/lib/badge";
// import 'styles/scss/header.scss';
// import { ChatSelector } from 'redux/Chat/selectors';
import { NewsQueries } from "../../helpers/GraphqlQueriesLib";
import { Context } from "../../context/globalContext";
import { routes } from "../../helpers/routes";
import ImgAccount from "../../assets/images/sprites/icons-account.svg";
import ImgGaba from "../../assets/images/sprites/gabaMidnight.png";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import moment from "moment";
import OneSignal from "react-onesignal";
import HeaderMenu from "./HeaderMenu";
import NotificationsModal from "./NotificationsModal";
import { CONNECTIONS_LIST } from "../../helpers/graphqlSubscription";
import useConnectionUsers from "../hook/useConnectionUsers";
import { GET_ROCKET_UNREAD_NOTIFICATIONS } from "../../helpers/graphqlQueries";
import { Menu, Dropdown } from 'antd';
import { Icon } from "semantic-ui-react";


export default function Header() {
  const {
    state: { isAuth, user: userProfile },
    dispatch: { logout },
  } = useContext(Context);
  const email = userProfile?.email;
  const username = userProfile?.username;
  const { data, loading } = useSubscription(NewsQueries.SUBS_GET_ARTICLES, {
    variables: { userEmail: email },
  });

  const { handleConnect, declineConnectionById, acceptConnectionById } = useConnectionUsers()
  const { data:connectionList } = useSubscription(CONNECTIONS_LIST,{variables:{username}})
  const [ userActionMutation ] = useMutation(NewsQueries.MUTATION_USERS_ACTION);
  const { data:unreadRocketNotifications, refetch:refetchUnreadRocketNotifications} = useQuery(GET_ROCKET_UNREAD_NOTIFICATIONS,{variables:{email}})
  

  // const { listLastMessage } = useSelector(ChatSelector);

  const [articlesCount, setArticlesCount] = useState(0);
  const [unreadArticles, setUnreadArticles] = useState([]);
  const [recommendedCount, setRecommendedCount] = useState(0)
  const [notificationCount, setNotificationCount] = useState(0);
  const [connectionRequestCount, setConnectionRequestCount] = useState(0);
  const [unreadRocketNotificationsCount, setUnreadRocketNotificationsCount] = useState(0);
  const [showNotificationsModal, setShowNotificationsModal] = useState(false)

  useEffect(() => {
    if (data) {
      setUnreadArticles(data.articles);
      setArticlesCount(data.articles.length);
    }
    if (connectionList){
      setConnectionRequestCount((connectionList.users_connection)?.filter(r=>r.sender!=="Recommended"&&r.sender!==username).length||0)
      setRecommendedCount((connectionList.users_connection)?.filter(r=>r.sender==="Recommended").length||0)
    }
    if(unreadRocketNotifications){
      setUnreadRocketNotificationsCount((unreadRocketNotifications?.getRocketUnreadNotifications?.result||[]).length)
    }
  }, [data,connectionList,unreadRocketNotifications]);

  useEffect(() => {
    const intervalRefetch = setInterval(() => {
      refetchUnreadRocketNotifications()
    }, 60000);
    return ()=>{
      clearInterval(intervalRefetch)
    }
  }, [])

  // useEffect(() => {
  //   let count = 0;
  //   listLastMessage.forEach(item => {
  //     if (
  //       item.is_received === false &&
  //       userProfile.email !== item.sender_email
  //     ) {
  //       count = count + 1;
  //     }
  //   });
  //   setNotificationCount(count);
  // }, [listLastMessage, userProfile]);

  // function onComplete (data){
  //   console.log('recommended',data)
  // } 

  const signOut = () => {
    OneSignal.removeExternalUserId(email);
    //OneSignal.setSubscription(false);
    firebase.auth().signOut();
    logout();
  };

  // const adminList = ["candice.blacknall@gogaba.co"];

  // function handleShowMenu() {
  //   changeShowMenu(true);
  // }

  const removeArticleFromState = (isRemoved) => async (idArticle) => {
    const filteredArticles = unreadArticles.filter(
      (article) => article.id !== parseInt(idArticle)
    );
    setUnreadArticles(filteredArticles);
    setArticlesCount(filteredArticles.length);
    const variables = {
      userEmail: email,
      idArticle,
      isRemoved,
      isRead: !isRemoved,
    };
    await userActionMutation({ variables });
  };

  const removeArticleClick = async ({ target }) => {
    await removeArticleFromState(true)(target.id);
  };
  const readArticleClick = async ({ target }) => {
    await removeArticleFromState(false)(target.id);
  };

  return (
    <Fragment>

      <HeaderContainer>
        <DirectionBrandMenu>
          <BrandContainer>
            <NavLink style={{ eight: '20px' }} to='/'>
              <img style={{ height: '20px' }}src={ImgGaba} alt='logo' />
            </NavLink>
          </BrandContainer>
          <HeaderMenu synapseNotificationsCount={unreadRocketNotificationsCount}/>
        </DirectionBrandMenu>
        <AccountContainer>
          <NotificationButton 
            onClick={(e)=>{
              if(showNotificationsModal)return
              e.preventDefault()
              setShowNotificationsModal(true)
            }} 
          >
            <Badge count={articlesCount+recommendedCount+connectionRequestCount+unreadRocketNotificationsCount} style={{ padding: "3px" }}>
              <BellFilled style={{ fontSize: "22px", color: "#111741" }} />
            </Badge>
            <NotificationsModal
              myEmail={email}
              myUsername={username}
              show={!loading && (moment(userProfile?.due_date).diff(
                moment(firebase.firestore.Timestamp.now().toMillis())
              ) >= 0) && showNotificationsModal }
              recommended={(connectionList?.users_connection)?.filter(r=>r.sender==="Recommended")||[]}
              recommendedCount={recommendedCount}
              articlesCount={articlesCount}
              unreadArticles={unreadArticles}
              readArticleClick={readArticleClick}
              removeArticleClick={removeArticleClick}
              declineConnectionById={declineConnectionById}
              acceptConnectionById={acceptConnectionById}
              handleConnect={handleConnect}
              connectionsRequest={(connectionList?.users_connection)?.filter(r=>r.sender!=="Recommended"&&r.sender!==username)||[]}
              connectionsRequestCount={connectionRequestCount}
              unreadRocketNotifications={unreadRocketNotifications?.getRocketUnreadNotifications?.result||[]}
              unreadRocketNotificationsCount={unreadRocketNotificationsCount}
              updateUnreadRcoketNotifications={refetchUnreadRocketNotifications}
              closeModal={()=>setShowNotificationsModal(false)}
            />
          </NotificationButton>
          {/* <IconContainer className='notification'>
            <a
              className='btn-chat-notification'
              onClick={(e) => {
                e.preventDefault();

                moment(userProfile?.due_date).diff(
                  moment(firebase.firestore.Timestamp.now().toMillis())
                ) >= 0
                  ? setChatModal(true)
                  : alert(
                      "Want to keep in touch? 😃 Upgrade you membership to chat with your mentors, tutors, and friends"
                    );
              }}
            >
              <Badge style={{ padding: "3px" }} count={notificationCount}>
                <MessageOutlined
                  style={{ fontSize: "22px", color: "#111741" }}
                />
              </Badge>
            </a>
          </IconContainer> */}
          <DropdownAccount
            overlay={(
              <Menu>
                <Link to={`/home/${userProfile.username}`} style={{ alignItems: "center" }}>
                  <MembershipText>My Profile</MembershipText>
                </Link>
                <Link to={`/membership`} style={{ alignItems: "center" }}>
                  <MembershipText>Membership</MembershipText>
                </Link>
                <SignOutText onClick={() => signOut()}>Sign out</SignOutText>
              </Menu>
            )}>
              <MoreButton>
                <img
                  style={{ marginRight: 8, marginBottom: 4 }}
                  src={ImgAccount}
                  alt=""
                />
                <UserText>{userProfile.username||""}</UserText>
                <Icon name='caret down' />
              </MoreButton>

        </DropdownAccount>
          
          {/* <AccountMember>
            {isAuth && (
              <Link to={`/`} style={{ display: "flex", alignItems: "center" }}>
                <img
                  style={{ marginRight: 18, marginBottom: 4 }}
                  src={ImgAccount}
                  alt=""
                />
                <div>
                  <UserText>{userProfile.username}</UserText>
                </div>
              </Link>
            )}
            <DropDown>
              <Link to={`/membership`} style={{ alignItems: "center" }}>
                <MembershipText>Membership</MembershipText>
              </Link>

              <SignOutText onClick={() => signOut()}>Sign out</SignOutText>
            </DropDown> 
          </AccountMember> */}
        </AccountContainer>
      </HeaderContainer>
    </Fragment>
  );
}

const MoreButton = styled.span`
  display:flex;
  flex-direction: row;
  cursor: pointer;
  padding: 8px 4px 8px 16px;
`;
const DropdownAccount = styled(Dropdown)`
  margin: 0 8px;
`;
const DirectionBrandMenu = styled.div`
  display:flex;
  flex:1;
  align-items: center;
  @media (max-width: 700px) {
    flex-direction: row-reverse;
    justify-content: flex-end;
  }
`;
const IconContainer = styled.div`
  padding: 0px 15px;
`;
const NotificationButton = styled.button`
  border: none;
  background: none; 
  outline: none;
`;
const ContentList = styled.div`
  display: none;
  position: absolute;
  top: 40px;
  right: 150px;
  background-color: white;
  width: 300px;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  color: #111741;
  div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: nowrap;
  }
  a {
    text-align: center;
    color: #111741;
    padding: 6px 16px;
    text-decoration: none;
    display: block;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    :hover {
      font-weight: bold;
    }
  }
  span {
    padding: 6px 16px;
    :hover {
      cursor: pointer;
      font-weight: bold;
      font-size: 1.2em;
    }
  }
`;

const NewsContainer = styled(IconContainer)`
  cursor: pointer;
  /* &:hover ${ContentList} {
    display: block;
  } */
`;
const FreeTrialText = styled.label`
  max-width: 300px;
  text-align: center;
  color: #333;
`;

const HeaderContainer = styled.header`
  display: flex;
  margin: 0 40px;
  height: 60px;
  color: #0065f2;
  background-color: #fff;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 8px 10px -6px rgba(0, 101, 242, 0.1);
  @media (max-width: 480px) {
    margin: 0;
  }
`;
const BrandContainer = styled.div`
  display: flex;
  padding: 16px 0;
  align-items: center;
`;
const AccountContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
const UserText = styled.span`
  vertical-align: middle;
  font-size: 20px;
  font-weight: 700;
  color: #111741;
`;
const LastName = styled.span`
  @media (max-width: 720px) {
    display: none;
  }
`;
const DropDown = styled.div`
  display: none;
  position: absolute;
  top: 20px;
  right: 0px;
  background-color: #fff;
  min-width: 160px;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  z-index: 1;
  color: #111741;
`;
const AccountMember = styled.div`
  position: relative;
  display: inline-block;
  padding-left: 16px;
  margin-right:30px;
  &:hover ${DropDown} {
    display: block;
  }
`;
const SignOutText = styled.a`
  color: #111741;
  padding: 0 12px 8px 12px;
  text-decoration: none;
  display: block;
  font-size: 20px;
`;

const MembershipText = styled.a`
  color: #111741;
  padding: 0 12px 8px 12px;
  text-decoration: none;
  display: block;
  font-size: 20px;
`;
